import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'ng-casto-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent {
  constructor(
    public modal: ModalService,
    public customer: CustomerService
  ) {}

  signout() {
    this.customer.logout();
    this.modal.close();
  }
}
